import api from './api';

/**
 * Get feed items
 * @param {Object} options - Pagination and filter options
 * @param {number} options.itemsPerPage - Number of items per page
 * @param {number} [options.beforeId] - Get items with ID smaller than this (oldest/smallest ID for cursor pagination)
 * @param {string[]} [options.types] - Filter by item types
 * @param {number[]} [options.sports] - Filter by sport IDs
 * @returns {Promise<Array>} Array of feed items
 */
export const getFeed = async ({ itemsPerPage, beforeId, types, sports }) => {
  const params = new URLSearchParams();
  params.append('itemsPerPage', itemsPerPage);

  if (beforeId !== undefined) {
    params.append('beforeId', beforeId);
  }

  if (types && types.length > 0) {
    types.forEach((type) => params.append('types[]', type));
  }

  if (sports && sports.length > 0) {
    sports.forEach((sport) => params.append('sports[]', sport));
  }

  const response = await api.get('/api/feed', { params });

  return response.data;
};

/**
 * Get count of new items since the given ID
 * @param {number} afterId - Get count of items with ID greater than this (newest/highest ID)
 * @param {Object} [filters] - Filter options
 * @param {string[]} [filters.types] - Filter by item types
 * @param {number[]} [filters.sports] - Filter by sport IDs
 * @returns {Promise<{count: number}>} Object with count of new items
 */
export const getNewItemsCount = async (afterId, { types, sports } = {}) => {
  const params = new URLSearchParams();

  if (types && types.length > 0) {
    types.forEach((type) => params.append('types[]', type));
  }

  if (sports && sports.length > 0) {
    sports.forEach((sport) => params.append('sports[]', sport));
  }

  const response = await api.get(`/api/feed/${afterId}/count`, { params });

  return response.data;
};

/**
 * Get a single feed item by ID
 * @param {number} id - Feed item ID
 * @returns {Promise<Object>} Feed item data
 */
export const getFeedItem = async (id) => {
  const response = await api.get(`/api/feed/${id}`);

  return response.data;
};
